import firebase from 'firebase/app'
import "firebase/auth"
/* eslint-disable */
export const user = {
    defaultUser: {
        firstName: "",
        lastName: "",
        canSignIn: false,
        email: "",
        password: "",
    },
    signIn: (email, password) => {
        return firebase
            .auth()
            .signInWithEmailAndPassword(email, password)
            .then((user) => {
            })
            .catch(function (error) {
            });
    },
    signOut: () => {
        return firebase
            .auth()
            .signOut()
            .then(function () {

            })
            .catch(function (error) {
                console.log("sign-out error", error);
                // An error happened.
            });
    }
}